import React from "react";

const map = {
  Nuevo: "pill-nuevo",
  Interesado: "pill-interesado",
  Agendado: "pill-agendado",
  Confirmado: "pill-confirmado",
  Atendido: "pill-atendido",
  "No asistió": "pill-no-asistio",
  Recuperación: "pill-recuperacion",
  Inactivo: "pill-inactivo",
  Urgente: "pill-urgente",
  Perdido: "pill-perdido",
  Seguimiento: "pill-seguimiento",
  Cancelado: "pill-cancelado",
  Pendiente: "pill-pendiente",
};

export default function StatusPill({ status, className = "" }) {
  const cls = map[status] || "pill-inactivo";
  return (
    <span className={`pill ${cls} ${className}`} data-testid={`status-pill-${(status || "").toLowerCase()}`}>
      {status}
    </span>
  );
}
